<!-- DIALOG SHOWN WHEN CHANGING LOCATION OF MULTPLE ARTWORKS 
IT CAN BE OPENED FROM ARTWORKS TABLE OR TOOLBAR -->

<template>
  <div>
    <v-dialog v-model="showDialog" max-width="900px" class="rounded-card" persistent>
      <v-card class="pt-0 rounded-card">

        <v-card-title class="title red white--text px-4 mb-4 pt-3 pb-2">
          {{ batchResults.length > 0 ? 'Confirmed Batch Results' : 'Add Location History Entry and Change Location' }}
          <span v-if="batchResults.length == 0">&nbsp;of {{ selected.length }} Artworks</span>
          <v-spacer></v-spacer>
          <v-btn outline small color="white" @click="closeChangeLocationDialog" :disabled="batchSaving">
            {{ batchResults.length > 0 ? 'Close' : 'Cancel' }}
          </v-btn>
        </v-card-title>

        <template v-if="!batchSaving && batchResults.length == 0">
        <!-- FORM FOR LOCATION CHANGE -->
        <v-layout row wrap mx-4>
          <v-flex xs12>
            <v-autocomplete :items="locations" v-model="artwork_location_log.artwork_location_id" item-text="name"
              item-value="id" label="New Location" clearable></v-autocomplete>
          </v-flex>

          <!-- Reason -->
          <v-flex class="sm12 md6 pr-3">
            <v-text-field v-model="artwork_location_log.reason" name="reason" label="Reason" clearable></v-text-field>
          </v-flex>

          <!-- Shipper -->
          <v-flex class="sm12 md6">
            <v-text-field v-model="artwork_location_log.shipper" name="shipper" label="Shipper" clearable></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field v-model="artwork_location_log.note" label="Note" class="pr-0" clearable></v-text-field>
          </v-flex>

        <!-- IN OUT -->
        <v-flex class="xs6 mb-0 pl-3 mt-1 pt-3">
          <!-- <v-btn-toggle v-model="toggle" @change="saveField(toggle)">
                <v-btn small flat v-for="s in f_field.selection" :key="s.id ? s.value : s" class="px-2" :value="s.value">
                                                                          <span> {{s.name}} </span>
                                                                          </v-btn>
                                                                      </v-btn-toggle>             -->
            <v-btn-toggle mandatory v-model="artwork_location_log.storage" active-class="activeToggle">
              <v-btn value="in" small flat class="px-3">
                <v-icon small>call_received</v-icon> IN
              </v-btn>
              <v-btn value="out" small flat class="px-3">
                OUT <v-icon small>call_made</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>

          <!-- DATE -->
          <v-flex xs6>
            <!-- :return-value.sync="artwork_location_log.change_date" -->
            <v-menu v-model="menu2a" ref="menu2a" :close-on-content-click="true" :nudge-right="40" lazy landscape
              transition="scale-transition" offset-y full-width min-width="290px">
              <v-text-field v-model="artwork_location_log.change_date" slot="activator" label="Change Date"
                prepend-inner-icon="event" readonly></v-text-field>
              <v-date-picker persistent color="black" v-model="artwork_location_log.change_date"></v-date-picker>
              <!-- @input="save(artwork_location_log.change_date)" -->
              <!-- @input="$refs.menu2.save(artwork_location_log.change_date)" -->
            </v-menu>
          </v-flex>
        </v-layout>

        <div v-if="artwork_location_log.artwork_location_id && artwork_location_log.change_date">

          <v-card-title class="subheading font-weight-medium pl-4 py-2 my-1 black white--text">
            Select Artwork Packings to include in this action
        </v-card-title>

          <!-- LISTING OF ARTWORKS AND PACKINGS TO CHANGE -->
          <v-container grid-list-xs text-xs-start>
            <v-layout row wrap mx-0 pl-0 pt-0>
              <v-flex xs12 pt-0>
                <v-checkbox class="ml-2 mt-0 pt-0 pb-2" label="Include all Packings of All Artworks"
                  @change="moveAllPackings($event)" v-model="moveAllPackingsSwitch" value="1" hide-details color="black"
                  :indeterminate="
                    this.selectedPackings.length != 0 &&
                    this.selectedPackings.length != this.packings.length
                  "></v-checkbox>
                  <div style="font-weight: 500;" class="ml-2 mt-2 title" >
                    {{ this.selectedPackings.length }} of {{ this.packings.length }} Packings selected for update.<br >
                    {{ this.selected.length }} Artworks selected for update.
                  </div>
                  <div class="ml-2 mt-2">
                    This is a preview based on currently loaded history. Rails will confirm the stored result for every target after saving.
                  </div>

                <!-- LIST SELECTED ARTWORKS AND PACKINGS  -->
                <v-card v-for="a in this.selected" :key="a.id" xs12 my-0 pb-0 pt-0 pl-2 class="rounded-card-small">

                  <!-- GENERAL ARTWORK INFO -->
                  <v-card-title xs12 class="title mt-3 pt-3 grey lighten-3 pb-3 justify-space-between ">
                    {{ a.title }}, {{ a.accession_number }}
                    <v-btn color="white" icon @click="removeArtworkFromSelection(a)">X</v-btn>
                  </v-card-title>
                  <v-card-title xs12 class="title my-0 pt-0 pb-3 grey lighten-3">
                    <small> {{ a.name }}</small>
                  </v-card-title>

                  <v-card-title xs12 class="subtitle mt-0 pb-2 pt-2 grey lighten-5">
                    Current Artwork Location
                    <v-icon class="mx-2" small color="black">adjust</v-icon>
                    {{ get_location_name(a.artwork_location_id) }}
                  </v-card-title>
                  <!-- {{ a.id }} -->
                  <!-- {{ lastLocationLogArtwork(a.id) }} -->
                  <!-- {{ lastArtworkChangeDate(a.id) }} -->
                  <!-- this.lastArtworkChangeDate(a.id) -->

                  <!-- if date is later than latest change and location_id is different from current, show message that artwork will be changed -->
                  <v-flex green--text mx-3>
                    Location History entry for this Artwork will be created.
                  </v-flex>
                  <v-flex v-if="movementWouldBeLatest(lastLocationLogArtwork(a.id))
                    && artwork_location_log.artwork_location_id != a.artwork_location_id" green--text
                    font-weight-medium pb-2 mx-3>
                    Current Artwork Location will be also changed:<br />
                    <!-- artwork_location_log.change_date: {{ artwork_location_log.change_date }}<br /> -->
                    <!-- lastLocationLogArtwork.change_date: {{ lastLocationLogArtwork(a.id).change_date }}<br /> -->
                    {{ get_location_name(a.artwork_location_id) }} =>
                    <b>{{ get_location_name(artwork_location_log.artwork_location_id) }}</b>
                  </v-flex>

                  <!-- if conditions are not met, show for each condition a message -->
                  <v-flex v-else>
                    <div v-if="artwork_location_log.artwork_location_id == a.artwork_location_id"
                      class="red--text mx-3 pb-2">
                      This artwork's current location will <b>NOT</b> be changed, because artwork's location is the same
                      as selected location.
                    </div>
                    <div v-if="!movementWouldBeLatest(lastLocationLogArtwork(a.id))"
                      class="mx-3 pb-2 red--text">
                      This artwork's current location will <b>NOT</b> be changed, because a location
                      history entry with newer Change Date exists.
                    </div>
                  </v-flex>

                  <!-- IF ARTWORK HAS PACKINGS LIST THEM -->
                  <v-flex v-if="getArtworkPackings(a.id) && getArtworkPackings(a.id).length > 0" mx-0 mb-2 pb-2>

                    <!-- CHANGE ALL PACKINGS CHECKBOX -->
                    <v-card-title xs12 class="pt-0 mt-0 pb-2">
                      <v-checkbox @change="moveOrRemoveAllPackingsforArtwork($event, a.id)" color="black" hide-details
                        class="py-0 small mb-1 mt-2" label="Include all Artwork packings" v-model="selectedArtworks"
                        :indeterminate="
                          selectedPackings.length != 0 &&
                          hasSomePackingsSelected(a.id)
                        " :value="a.id"></v-checkbox>
                      <!-- </v-flex> -->
                    </v-card-title>

                    <!-- LIST ALL PACKINGS -->
                    <v-layout v-for="ap in packings.filter((aap) => aap.artwork_id == a.id)" :key="ap.id" xs12
                      align-center row wrap fill-height px-3 pb-1>
                      <div style="width:100%">
                        <v-checkbox color="black" class="my-0 py-0 shorten-text" hide-details
                          :label="`${ap.colli}, ${ap.packing}, ${ap.contents}`"
                          v-model="selectedPackings"
                          :value="ap.id"></v-checkbox>
                        <v-flex green--text ml-4 v-if="selectedPackings.includes(ap.id)">
                          Location History entry for this Packing will be created.
                        </v-flex>

                      </div>
                      <div class="ml-4 mt-1 mb-1">
                        <v-icon class="mx-2" small color="black">adjust</v-icon> {{
                          get_location_name(ap.artwork_location_id)
                        }}
                        <span v-if="!ap.artwork_location_id">
                          No Packing Location entered.
                        </span>
                      </div>

                      <!-- {{ ap.id }} -->
                      <!-- {{ lastLocationLogArtworkPacking(ap.id) }} -->

                      <v-flex v-if="selectedPackings.includes(ap.id)">

                        <!-- IF CHANGE DATE IS NEWER THAN LAST PACKING'S HISTORY ENTRY, IT WILL BE CHANGED -->
                        <div class="green--text"
                          v-if="movementWouldBeLatest(lastLocationLogArtworkPacking(ap.id)) && artwork_location_log.artwork_location_id != ap.artwork_location_id">
                          <span class="ml-2 mr-1"> => </span>
                          <b>{{ get_location_name(artwork_location_log.artwork_location_id) }}</b>
                        </div>

                      <!-- ELSE - IT WILL NOT BE CHANGED -->
                      <!-- <v-flex xs12 v-else class="red--text ml-4 pl-2 my-1">
                                                                            This packing's current location will <b>NOT</b> be changed, because a location
                                                                            history entry with newer Change Date exists.
                                                                          </v-flex> -->

                        <!-- if conditions are not met, show for each condition a message -->
                        <v-flex v-else>
                          <div
                            v-if="artwork_location_log.artwork_location_id == ap.artwork_location_id"
                            class="red--text mx-3 pb-2">
                            This packing's current location will <b>NOT</b> be changed, because it's location is the same
                            as selected new location.
                          </div>
                          <div v-if="!movementWouldBeLatest(lastLocationLogArtworkPacking(ap.id))"
                            class="mx-3 pb-2 red--text">
                            This packing's current location will <b>NOT</b> be changed, because a location
                            history entry with newer Change Date exists.
                          </div>
                        </v-flex>
                      </v-flex>
                    </v-layout>

                  </v-flex>

                </v-card>

              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-4 justify-end mr-4 pr-0">
            <v-btn outline small @click="closeChangeLocationDialog">Cancel</v-btn>

            <v-btn @click="changeLocation" small :dark="
              !(
                artwork_location_log.artwork_location_id == null ||
                artwork_location_log.artwork_location_id == ''
              ) &&
              !(
                artwork_location_log.change_date == null ||
                artwork_location_log.change_date == ''
              )
            " :disabled="
  artwork_location_log.artwork_location_id == null ||
  artwork_location_log.artwork_location_id == '' ||
  artwork_location_log.change_date == null ||
  artwork_location_log.change_date == '' ||
  selected.length == 0
">Change</v-btn>
          </v-card-actions>
        </div>
        </template>

        <v-card-text v-if="batchSaving" class="text-xs-center py-5">
          <v-progress-circular indeterminate color="red" :size="48"></v-progress-circular>
          <h3 class="mt-3">Saving movement {{ completedBatchRequests + 1 }} of {{ totalBatchRequests }}…</h3>
          <div>The dialog will remain open until every target has a confirmed result.</div>
        </v-card-text>

        <v-card-text v-if="batchResults.length > 0" class="px-4 pt-0">
          <v-alert :value="true" :type="allBatchResultsComplete ? 'success' : 'warning'" outline>
            {{ completedBatchResultCount }} of {{ batchResults.length }} movements completed.
            <span v-if="!allBatchResultsComplete">Review every item marked as needing attention.</span>
          </v-alert>

          <v-card
            v-for="(result, index) in batchResults"
            :key="`batch-movement-result-${index}`"
            class="mb-2 elevation-0 grey lighten-4"
          >
            <v-card-text class="py-3">
              <b>{{ result.target_label }}</b>
              <span class="ml-2">{{ result.status }}</span><br>
              <span v-if="result.history && result.history.saved">
                History entry #{{ result.history.id }} was saved.
              </span>
              <span v-else class="red--text">History was not saved.</span><br>
              <span v-if="result.current_state">
                Confirmed current location:
                <b>{{ result.current_state.location_name || get_location_name(result.current_state.location_id) || 'None' }}</b>.
                <span v-if="result.current_state.changed"> Current state changed.</span>
                <span v-else-if="result.current_state.reason == 'newer_movement_exists'">
                  Current state stayed unchanged because a newer movement exists.
                </span>
                <span v-else-if="result.current_state.reason == 'already_at_destination'">
                  It was already at this location.
                </span>
              </span>
              <div v-if="result.status != 'complete'" class="red--text mt-1">
                {{ batchResultError(result) }}
              </div>
            </v-card-text>
          </v-card>

          <v-card-actions class="px-0 pb-3 justify-end">
            <v-btn v-if="canChangeBatchAfterResult" small flat @click="editBatchAfterResult">Change details</v-btn>
            <v-btn small flat @click="startAnotherBatch" :disabled="!allBatchResultsComplete">New batch</v-btn>
            <v-btn small dark @click="closeChangeLocationDialog">Close</v-btn>
          </v-card-actions>
        </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import { serverBus } from '../../../main'

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

function compareMovementLogsDescending(a, b) {
  if (a.change_date !== b.change_date) return a.change_date > b.change_date ? -1 : 1
  const aTime = a.change_time || ''
  const bTime = b.change_time || ''
  if (aTime !== bTime) return aTime > bTime ? -1 : 1
  return Number(b.id || 0) - Number(a.id || 0)
}

export default {
  props: ['showDialog', 'selected'],
  watch: {
    selected: function () {
      if (this.showDialog) this.loadMovementData()
    },
    showDialog: function (isOpen) {
      if (isOpen) this.loadMovementData()
    }
  },
  data() {
    return {
      selectedPackings: [],
      selectedArtworks: [],
      moveAllPackingsSwitch: null,
      packings: [],
      logs: [],
      menu2a: false,
      batchSaving: false,
      batchResults: [],
      completedBatchRequests: 0,
      totalBatchRequests: 0,
      artwork_location_log: {
        storage: 'in',
        note: '',
        change_date: '',
        copy: 'artwork',
        storage_in: '',
        storage_out: '',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: '',
        artwork_id: '',
      },
    }
  },
  methods: {
    movementWouldBeLatest(lastLog) {
      if (!lastLog) return true
      if (this.artwork_location_log.change_date > lastLog.change_date) return true
      if (this.artwork_location_log.change_date < lastLog.change_date) return false

      const proposedTime = this.artwork_location_log.change_time || ''
      const lastTime = lastLog.change_time || ''
      return proposedTime >= lastTime
    },
    removeArtworkFromSelection(artwork) {
        var index = this.selected.indexOf(artwork)
        if (index > -1) {
          this.selected.splice(index, 1)
      }
    },
    lastArtworkChangeDate(artwork_id) {
      var last = this.lastLocationLogArtwork(artwork_id).change_date
      if (last) {
        return last
      } else {
        return '1900-01-01'
      }
    },
    lastArtworkPackingChangeDate(packing_id) {
      var last = this.lastLocationLogArtworkPacking(packing_id).change_date
      if (last) {
        return last
      } else {
        return '1900-01-01'
      }
    },
    lastLocationLogArtworkPacking(id) {
      return this.getLastLog(this.logs, 'packings', id)
    },
    lastLocationLogArtwork(id) {
      return this.getLastLog(this.logs, 'artwork', id)
    },
    getLastLog(logs, copy, id) {
      if (copy == 'packings') {
        if (logs && logs.length > 0) {
          var out = logs
            .filter((ll) => ll.artwork_packing_id === id)
            .sort(compareMovementLogsDescending)[0]
          if (out) {
            return out
          } else {
            return ''
          }
        } else {
          return ''
        }
      } else {
        if (logs && logs.length > 0) {
          var out = logs
            .filter((ll) => ll.copy === copy && ll.artwork_id == id)
            .sort(compareMovementLogsDescending)[0]
          if (out) {
            return out
          } else {
            return ''
          }
        } else {
          return ''
        }
      }
    },
    
    /**
     * Toggles the selection of all packings for a specific artwork.
     * Adds all packings of the artwork to selectedPackings if checked, otherwise removes them.
     * @param {Boolean} isChecked - Whether the checkbox is checked.
     * @param {Number} artworkId - The ID of the artwork.
     */
    // moveOrRemoveAllPackingsforArtwork(checkboxValue, artworkId) {
    //   const artworkPackingsIds = this.packings
    //     .filter(packing => packing.artwork_id === artworkId)
    //     .map(packing => packing.id);
    //     console.log(artworkPackingsIds)
    //   if (checkboxValue === artworkId) {
    //   console.log(this.selectedPackings)
    //       // Add all packings for this artwork, avoiding duplicates
    //       this.selectedPackings = [...new Set([...this.selectedPackings, ...artworkPackingsIds])];

    //   } else {
    //   console.log(this.selectedPackings)
    //       // Remove all packings for this artwork
    //       this.selectedPackings = this.selectedPackings.filter(id => !artworkPackingsIds.includes(id));
    //   }
    // },

    /**
     * Toggles the selection of all packings for a specific artwork based on the checkbox state.
     * Adds all packings of the artwork to selectedPackings if checked, otherwise removes them.
     * @param {Array} checkboxValue - The value from the checkbox, either an empty array or an array with packing IDs.
     * @param {Number} artworkId - The ID of the artwork.
     */
     moveOrRemoveAllPackingsforArtwork(checkboxValue, artworkId) {
        const artworkPackingsIds = this.packings
            .filter(packing => packing.artwork_id === artworkId)
            .map(packing => packing.id);

        if (checkboxValue.includes(artworkId)) {
            // Add all packings for this artwork, avoiding duplicates
            this.selectedPackings = Array.from(new Set([...this.selectedPackings, ...artworkPackingsIds]));
        } else {
            // Remove all packings for this artwork
            this.selectedPackings = this.selectedPackings.filter(id => !artworkPackingsIds.includes(id));
        }
    },

    // NOT USED
    moveAllPackingsforArtwork(e, id) {
      // console.log(id)
      // console.log(this.selectedPackings)
      this.selectedPackings = this.selectedPackings.filter(
        (p) => this.packings.find((pp) => pp.id == p).artwork_id != id
      )
      console.log(this.selectedPackings)
      if (e.includes(id)) {
        // console.log('e')
        // console.log(e[0])
        // console.log('e')
        // console.log(id)
        this.selectedPackings = this.selectedPackings.concat(
          this.packings.filter((p) => p.artwork_id == id).map((ppp) => ppp.id)
        )
      }
      if (!this.selectedPackings) {
        this.selectedPackings = []
      }
      // console.log(this.selectedPackings)
    },
    /**
     * Moves all packings.
     *
     * @param {Event} e - The event object.
     * @return {void} This function does not return a value.
     */
    moveAllPackings(e) {
      if (e) {
        this.selectedPackings = this.packings.map((p) => p.id)
      } else {
        this.selectedPackings = []
      }
    },
    loadMovementData () {
      return Promise.all([
        this.getPackings(),
        this.getLocationLogs()
      ]).catch((error) => {
        if (!error.response || error.response.status !== 401) {
          serverBus.$emit('showSnackbar', 'Could not load location movement data.', 'red')
        }
      })
    },
    getPackings () {
      var ids = this.selected.map((a) => a.id)
      return axios
        .get(`${this.$globals.apiserver}/artwork_packings.json`, {
          params: {
            // user_id: localStorage.getItem('user-token'),
            artwork_ids: ids,
          },
        })
        .then((r) => (this.packings = r.data))
    },
    getLocationLogs () {
      var ids = this.selected.map((a) => a.id)
      return axios
        .get(`${this.$globals.apiserver}/artwork_location_logs.json`, {
          params: {
            // user_id: localStorage.getItem('user-token'),
            artwork_ids: ids,
          },
        })
        .then((r) => (this.logs = r.data))
    },
    getArtworkPackings(id) {
      return this.packings.filter((p) => p.artwork_id == id)
      // console.log('Artwork Packings filtered')
    },
    closeChangeLocationDialog() {
      if (this.batchSaving) return

      this.resetBatchForm()
      this.batchResults = []
      this.$emit('hideDialog')
    },

    /**
     * Batch change of artwork and packings location and creating a new log entry.
     */
    async changeLocation() {
      this.batchSaving = true
      this.batchResults = []
      this.completedBatchRequests = 0
      const requests = this.buildBatchMovementRequests()
      this.totalBatchRequests = requests.length
      const results = []
      serverBus.$emit('showSnackbar', `Saving ${requests.length} location movements…`, 'orange')

      for (const request of requests) {
        if (request.local_result) {
          results.push({ ...request.local_result, target_label: request.label })
          this.completedBatchRequests += 1
          continue
        }

        try {
          const response = await axios.post(
            `${this.$globals.apiserver}/artwork_location_movements.json`,
            { artwork_location_movement: request.attributes }
          )
          results.push({ ...response.data, target_label: request.label })
          this.applyConfirmedBatchMovement(response.data)
        } catch (error) {
          const responseData = error.response && error.response.data
            ? error.response.data
            : {
                status: 'unknown',
                history: { saved: false, id: null },
                current_state: null,
                errors: { base: ['The server did not return a result. Do not retry until the stored state is checked.'] },
              }
          results.push({ ...responseData, target_label: request.label })
        }
        this.completedBatchRequests += 1
      }

      this.batchResults = results
      this.batchSaving = false
      this.$store.dispatch('loadArtworks')
      this.loadMovementData()

      if (this.allBatchResultsComplete) {
        serverBus.$emit('showSnackbar', `${results.length} location movements confirmed.`, 'green')
      } else {
        serverBus.$emit('showSnackbar', 'Some location movements need attention. Review the confirmed results.', 'red')
      }
    },
    buildBatchMovementRequests() {
      const base = {
        ...this.artwork_location_log,
        storage_in: this.artwork_location_log.storage === 'in'
          ? this.artwork_location_log.change_date
          : null,
        storage_out: this.artwork_location_log.storage === 'out'
          ? this.artwork_location_log.change_date
          : null,
        artwork_packing_id: null,
      }

      const artworkRequests = this.selected.map(artwork => ({
        label: `${artwork.title || 'Artwork'}, ${artwork.accession_number || artwork.id}`,
        attributes: {
          ...base,
          artwork_id: artwork.id,
          copy: 'artwork',
        },
      }))

      const packingRequests = this.selectedPackings.map(packingId => {
        const packing = this.packings.find(item => item.id === packingId)
        if (!packing) {
          return {
            label: `Packing #${packingId}`,
            local_result: {
              status: 'failed',
              history: { saved: false, id: null },
              current_state: null,
              errors: { artwork_packing: ['is no longer available in the loaded batch data'] },
            },
          }
        }
        const artwork = this.selected.find(item => item.id === packing.artwork_id)

        return {
          label: `${artwork ? artwork.title : 'Artwork'} — ${packing.colli || 'Packing'} ${packing.packing || ''}`.trim(),
          attributes: {
            ...base,
            artwork_id: packing.artwork_id,
            artwork_packing_id: packing.id,
            copy: 'packings',
          },
        }
      })

      return artworkRequests.concat(packingRequests)
    },
    applyConfirmedBatchMovement(result) {
      if (!result || result.status !== 'complete') return

      if (result.movement) this.$store.commit('ADD_LOG', result.movement)

      const state = result.current_state
      if (!state) return

      if (state.copy === 'packings') {
        const packing = this.packings.find(item => item.id === state.target_id)
        if (packing) {
          packing.artwork_location_id = state.location_id
          packing.location_id = state.location_id
        }
      } else {
        const artwork = this.selected.find(item => item.id === state.target_id)
        if (artwork) artwork.artwork_location_id = state.location_id
      }
    },
    batchResultError(result) {
      if (result.status === 'inconsistent') {
        return 'History and current state could not be confirmed as one consistent result. Do not repeat this movement until it is reviewed.'
      }

      const errors = result.errors || {}
      const messages = Object.keys(errors).reduce((all, field) => {
        const fieldMessages = Array.isArray(errors[field]) ? errors[field] : [errors[field]]
        return all.concat(fieldMessages.map(message => `${field}: ${message}`))
      }, [])
      return messages.join('; ') || 'The movement was not completed.'
    },
    editBatchAfterResult() {
      this.batchResults = []
      this.loadMovementData()
    },
    startAnotherBatch() {
      this.resetBatchForm()
      this.batchResults = []
      this.loadMovementData()
    },
    resetBatchForm() {
      this.artwork_location_log = this.defaultBatchLog()
      this.batchSaving = false
      this.selectedPackings = []
      this.selectedArtworks = []
      this.moveAllPackingsSwitch = null
      this.completedBatchRequests = 0
      this.totalBatchRequests = 0
    },
    defaultBatchLog() {
      return {
        storage: 'in',
        storage_in: '',
        storage_out: '',
        note: '',
        change_date: '',
        copy: 'artwork',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: '',
        artwork_id: '',
      }
    },
    /**
     * Check if there are any packings selected for a given artwork ID.
     * @param {number} id - The artwork ID to check against.
     * @returns {boolean} - True if there are selected packings, false otherwise.
     */
    hasSomePackingsSelected(id) {
      // Get the IDs of packings that have the given ID as artwork_id
      var apids = this.packings
        .filter((p) => p.artwork_id == id)
        .map((p) => p.id)

      // Filter the selectedPackings array to include only IDs that are in apids
      var selectedPackingsWithId = this.selectedPackings.filter((pp) => apids.includes(pp))

      // Return true if there are any selected packings with the given ID, false otherwise
      return selectedPackingsWithId.length > 0
    }
  },
  computed: {
    // selectedWithPackings() {
    //   return this.selected.filter((a) =>
    //     this.packings.find((p) => p.artwork_id == a.id)
    //   )
    // },
    locations() {
      return Object.assign([], this.$store.getters.enabled_locations).sort(
        dynamicSort('name')
      )
    },
    allBatchResultsComplete() {
      return this.batchResults.length > 0 &&
        this.batchResults.every(result => result.status === 'complete')
    },
    completedBatchResultCount() {
      return this.batchResults.filter(result => result.status === 'complete').length
    },
    canChangeBatchAfterResult() {
      return this.batchResults.length > 0 &&
        this.batchResults.every(result =>
          ['rejected', 'failed'].includes(result.status) &&
          (!result.history || !result.history.saved)
        )
    },
  },
}
</script>

<style scoped>
.shorten-text {
  width: 98%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rounded-card {
  border-radius: 12px;
}

.theme--light.v-label {
  color: rgb(0 0 0 / 70%);
}

.rounded-card-small {
  border-radius: 8px;
}
</style>

                <!-- <v-flex xs6 pr-3>
                    <v-text-field
                    :disabled="artwork_location_log.storage_out != ''"
                    v-model="artwork_location_log.storage_in"
                    label="Storage IN"
                    mask="####-##-##"
                    placeholder="YYYY-MM-DD"
                    clearable
                    ></v-text-field>
                </v-flex>

                <v-flex xs6>
                    <v-text-field
                    :disabled="artwork_location_log.storage_in != ''"
                    v-model="artwork_location_log.storage_out"
                    label="Storage OUT"
                    mask="####-##-##"
                    placeholder="YYYY-MM-DD"
                    clearable
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 pr-3>
                    <v-text-field
                    v-model="artwork_location_log.change_date"
                    label="Change Date"
                    mask="####-##-##"
                    placeholder="YYYY-MM-DD"
                    clearable
                    ></v-text-field>
                </v-flex> -->

                <!-- <v-flex xs6 pl-5 pt-3>
                <v-btn-toggle mandatory v-model="artwork_location_log.copy">
                <v-btn
                    flat
                    small
                    key="group1"
                    class="px-3"
                    input-value="artwork"
                    value="artwork"
                    >Artwork</v-btn
                >
                <v-btn
                    flat
                    small
                    key="group2"
                    class="px-3"
                    input-value="copy"
                    value="copy"
                    >Copy</v-btn
                >
                </v-btn-toggle>
            </v-flex> -->



// WEBPACK FOOTER //
// src/components/layout/toolbar_items/LocationChangeDialog.vue